import useLocalStorage from './useLocalStorage';
import { Idol } from '../types';

const useFetchedIdols = () => {
  const [fetchedIdols, setFetchedIdols] = useLocalStorage<Idol[]>('fetchedIdols', []);
  
  return { fetchedIdols, setFetchedIdols };
};

export default useFetchedIdols;